function getObjectFitSize(
  contains /* true = contain, false = cover */,
  containerWidth,
  containerHeight,
  width,
  height
) {
  var doRatio = width / height
  var cRatio = containerWidth / containerHeight
  var targetWidth = 0
  var targetHeight = 0
  var test = contains ? doRatio > cRatio : doRatio < cRatio

  if (test) {
    targetWidth = containerWidth
    targetHeight = targetWidth / doRatio
  } else {
    targetHeight = containerHeight
    targetWidth = targetHeight * doRatio
  }

  return {
    width: targetWidth,
    height: targetHeight,
    x: (containerWidth - targetWidth) / 2,
    y: (containerHeight - targetHeight) / 2,
  }
}

export const drawGraph = ({ dataArr, canvas, color }) => {
  let context = canvas.getContext('2d')
  let parent = canvas.offsetParent
  let width = parent.offsetWidth
  let height = parent.offsetHeight
  let GRAPH_TOP = 0
  let GRAPH_LEFT = 0
  let GRAPH_RIGHT = width

  canvas.width = width
  canvas.height = height
  const originalHeight = canvas.height
  const originalWidth = canvas.width

  const clientHeight = canvas.clientHeight
  const clientWidth = canvas.clientWidth

  let GRAPH_HEIGHT = height
  //let GRAPH_WIDTH = width
  let GRAPH_BOTTOM = GRAPH_HEIGHT - 3

  let dimensions = getObjectFitSize(
    true,
    clientWidth,
    clientHeight,
    originalWidth,
    originalHeight
  )

  let ratio = Math.min(
    clientWidth / originalWidth,
    clientHeight / originalHeight
  )

  // const dpr = window.devicePixelRatio || 1

  /*canvas.width = dimensions.width * dpr
  canvas.height = dimensions.height * dpr*/

  let arrayLen = dataArr.length

  let largest = 0
  for (let i = 0; i < arrayLen; i++) {
    if (+dataArr[i] > largest) {
      largest = +dataArr[i]
    }
  }

  context.clearRect(0, 0, dimensions.width * ratio, dimensions.height * ratio)
  // set font for fillText()
  // context.scale(ratio / dpr, ratio / dpr)
  context.beginPath()
  context.lineJoin = 'miter'
  context.strokeStyle = color
  context.lineWidth = 2

  const y = GRAPH_HEIGHT - (+dataArr[0] / largest) * GRAPH_HEIGHT + GRAPH_TOP

  context.moveTo(GRAPH_LEFT, y > GRAPH_BOTTOM ? GRAPH_BOTTOM : y)
  // draw reference value for day of the week
  // context.fillText('1', 15, GRAPH_BOTTOM + 25)
  for (let i = 1; i < arrayLen; i++) {
    const y =
      GRAPH_HEIGHT - (+dataArr[i] / largest) * GRAPH_HEIGHT + GRAPH_TOP + 2
    const x = (GRAPH_RIGHT / arrayLen) * i + GRAPH_LEFT + 2
    context.lineTo(
      x > GRAPH_RIGHT ? GRAPH_RIGHT : x,
      y > GRAPH_BOTTOM ? GRAPH_BOTTOM : y
    )
  }
  context.stroke()
}
